import { Dispatch, SetStateAction } from "react";
import { CustomEvent, Map } from "schemas/functions";

import StyledTextField from "components/Styled/TextField";
import { makeDeepCopy } from "utils/updateLocalState";

interface PartnershipFormProps {
  handleNext?: () => void;
  onboardingForm: Map;
  setOnboardingForm: Dispatch<SetStateAction<Map>>;
}

const PartnershipForm = ({
  handleNext,
  onboardingForm,
  setOnboardingForm,
}: PartnershipFormProps) => {
  const onSubmit = (e: CustomEvent) => {
    e.preventDefault();
    if (handleNext) handleNext();
  };

  const handleChange = (e: CustomEvent) => {
    const { name, value } = e.target;
    const copy = makeDeepCopy(onboardingForm);
    copy[name] = value;
    setOnboardingForm(copy);
  };

  return (
    <form onSubmit={onSubmit}>
      <StyledTextField
        label={
          <>
            Share an example of a past partnership and the results you created
            for them (share an example link if relevant)
          </>
        }
        fullWidth
        name="caseStudy"
        placeholder="I worked with Wayfair on an ad that generated 2M views!"
        onChange={handleChange}
        multiline
        minRows={2}
        value={onboardingForm?.caseStudy || ""}
        styles={{ mb: 2 }}
      />

      <StyledTextField
        label="Share 3-4 solid brands that you want to mention in your pitch"
        fullWidth
        name="mostImpressivePartnerships"
        placeholder="Skims, Motion, Amazon and Wayfair"
        onChange={handleChange}
        value={onboardingForm?.mostImpressivePartnerships || ""}
        styles={{ mb: 2 }}
      />
    </form>
  );
};

export default PartnershipForm;
